module.exports = __webpack_public_path__ + "img/background-lines.ce1f5b9d.svg";